import {
  IStateOffers,
  IPricing,
  IDeviceFamily,
  IRetailPriceRange,
  IDownPaymentRange,
  IpreRegDevicesResponse,
} from "@/apps/merchant3/models/IStateOffers";
import { IOptionDropdown } from "@/types/dropdown";
import { IModel } from "@/apps/merchant3/models/IStateCart";
import {
  IManufacturer,
  IRecommendedOffers,
  ISelfServiceOffers,
} from "@/apps/merchant3/services/carts.service";
import { ICartAccessory } from "@/apps/merchant3/types/CartAccessories";

const mutations = {
  LOAD_MANUFACTURER: (state: IStateOffers, payload: IManufacturer[]): void => {
    state.manufacturer = payload;
  },

  LOAD_MANUFACTURER_DROPDOWN: (
    state: IStateOffers,
    payload: IOptionDropdown[]
  ): void => {
    state.manufacturerDropdown = payload;
  },
  LOAD_PR_MANUFACTURER_DROPDOWN: (
    state: IStateOffers,
    payload: IOptionDropdown[]
  ): void => {
    state.prManufacturerDropdown = payload;
  },

  LOAD_PR_OFFERS: (
    state: IStateOffers,
    payload: IpreRegDevicesResponse
  ): void => {
    state.prOffers = payload;
  },

  LOAD_DEVICE_FAMILIES: (
    state: IStateOffers,
    payload: IDeviceFamily[]
  ): void => {
    state.deviceFamilies = payload;
  },

  LOAD_DEVICE_FAMILIES_DROPDOWN: (
    state: IStateOffers,
    payload: IOptionDropdown[]
  ): void => {
    state.deviceFamiliesDropdown = payload;
  },

  LOAD_RECOMMENDED_OFFERS: (
    state: IStateOffers,
    payload: IRecommendedOffers[]
  ): void => {
    state.recommendedOffers = payload;
  },

  LOAD_DEVICE_MODELS_DROPDOWN: (
    state: IStateOffers,
    payload: IOptionDropdown[]
  ): void => {
    state.deviceModelsDropdown = payload;
  },

  SET_SELECTED_MANUFACTURER: (
    state: IStateOffers,
    payload: IOptionDropdown
  ): void => {
    state.selectedManufacturer = payload;
  },

  SET_SELECTED_DEVICE_FAMILY: (
    state: IStateOffers,
    payload: IOptionDropdown
  ): void => {
    state.selectedDeviceFamily = payload;
  },

  SET_SELECTED_DEVICE_FAMILY_MODELS: (
    state: IStateOffers,
    payload: IModel[]
  ): void => {
    state.selectedFamilyModels = payload;
  },

  SET_SELECTED_DEVICE_MODEL: (
    state: IStateOffers,
    payload: IOptionDropdown
  ): void => {
    state.selectedDeviceModel = payload;
  },

  SET_SELECTED_CART_ACCESSORY: (
    state: IStateOffers,
    payload: ICartAccessory
  ): void => {
    state.selectedCartAccessory = payload;
  },

  SET_RETAIL_PRICE_RANGE: (
    state: IStateOffers,
    payload: IRetailPriceRange
  ): void => {
    state.selectedDeviceModelObject.minRetailPrice = payload.minRetailPrice;
    state.selectedDeviceModelObject.maxRetailPrice = payload.maxRetailPrice;
    state.selectedDeviceModelObject.minFinanceAmountIncrement =
      payload.minFinanceAmountIncrement;
  },

  SET_DOWN_PAYMENT_RANGE: (
    state: IStateOffers,
    payload: IDownPaymentRange
  ): void => {
    state.selectedDeviceModelObject.minDownPayment = payload.minDownPayment;
    state.selectedDeviceModelObject.maxDownPayment = payload.maxDownPayment;
    state.selectedDeviceModelObject.downPayment = payload.downPayment;
  },

  SET_SELECTED_DEVICE_MODEL_OBJECT: (
    state: IStateOffers,
    payload: IModel
  ): void => {
    state.selectedDeviceModelObject = payload;
  },

  SET_SELECTED_IMAGE_URL: (state: IStateOffers, payload: string): void => {
    state.selectedDeviceImageUrl = payload;
  },

  UPDATE_PRICING: (state: { pricing: IPricing }, payload: IPricing): void => {
    state.pricing = payload;
  },

  LOAD_DEVICE_BRANDS: (
    state: { deviceBrands: IOptionDropdown[] },
    payload: IOptionDropdown[]
  ): void => {
    state.deviceBrands = payload;
  },

  SET_OFFER_ERROR_MESSAGE: (state: IStateOffers, payload: string): void => {
    state.offerErrorMessage = payload;
  },
  SET_OFFER_ERROR_CODE: (state: IStateOffers, payload: number): void => {
    state.errorCode = payload;
  },
  SET_SHOULD_WAIT_FOR_CX: (state: IStateOffers, payload: boolean): void => {
    state.shouldWaitForCx = payload;
  },
  SET_LOADING: (state: IStateOffers, payload: boolean): void => {
    state.loading = payload;
  },
  RESET_OFFERS: (state: IStateOffers): void => {
    Object.keys(state).forEach((key) => (state[key] = null));
  },
  SET_OFFERS_WITH_DISCOUNT: (state: IStateOffers, payload: boolean): void => {
    state.offersWithDiscount = payload;
  },
  LOAD_SELF_SERVICE_OFFERS: (
    state: IStateOffers,
    payload: ISelfServiceOffers[]
  ): void => {
    state.selfServiceOffers = payload;
  },
};

export default mutations;
